import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

function DownloadPage() {
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const download = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/products/${id}`);
        const { filePath, name, price } = response.data;
        if (price !== 0 && price !== '0') {
          console.error('Download error: Not a free product');
          navigate('/payment-failed', { state: { productName: name } });
          return;
        }
        if (filePath) {
          const downloadLink = document.createElement('a');
          downloadLink.href = `${process.env.REACT_APP_API_URL}/${filePath}`;
          downloadLink.download = filePath.split('/').pop();
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
          navigate(`/product/${id}`); // Redirect back to product page
        } else {
          console.error('Download error: No file path');
          navigate('/payment-failed', { state: { productName: name } });
        }
      } catch (err) {
        console.error('Download error:', err);
        navigate('/payment-failed', { state: { productName: 'Unknown' } });
      }
    };
    download();
  }, [id, navigate]);

  return <div className="loading-container"><div className="loading-spinner"></div></div>;
}

export default DownloadPage;